<template>
  <header class="nav">
    <div class="wrap nav-in">
      <router-link to="/" class="logo-link">
        <img :src="logo" alt="GDQ Associates" class="logo-img" />
      </router-link>
      <div class="nav-right">
        <div class="acct">
          <span class="av">{{ initials }}</span>
          <span>{{ fullName }}</span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import logo from '../../assets/gdq-logo.png'

export default {
  name: 'LearningHubHeader',
  data () {
    return {
      logo
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    fullName () {
      return `${this.user.first_name || ''} ${this.user.family_name || ''}`.trim()
    },
    initials () {
      const f = (this.user.first_name || '').charAt(0)
      const l = (this.user.family_name || '').charAt(0)
      return (f + l).toUpperCase()
    }
  }
}
</script>

<style scoped>
.nav {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(244, 246, 247, 0.85);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--line);
}
.wrap {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 0 24px;
}
.nav-in {
  display: flex;
  align-items: center;
  gap: 28px;
  height: 68px;
}
.logo-link {
  display: block;
}
.logo-img {
  height: 30px;
  width: auto;
  display: block;
}
.nav-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 14px;
}
.acct {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 0.9rem;
  font-weight: 600;
  border: 1px solid var(--line);
  border-radius: 999px;
  padding: 5px 12px 5px 6px;
  background: var(--white);
}
.av {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--teal), var(--ink));
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 0.78rem;
  font-weight: 800;
}
</style>
